import styled from 'styled-components';

const StyledDivider = styled.div`
  width: 100%;
  height: 1px;
  background-color:rgba(255, 255, 255, 0.20);
  margin: 10px 0;
`;

export default StyledDivider;